import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const intervention_type_lists:SchemaTableOptions = {
    name:<string> 'intervention_type_lists',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'intervention_type', value: 'TINYINT UNSIGNED'},
        { column: 'code', value: 'VARCHAR(255) NOT NULL'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
    ]
}